import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { hexToCSSFilter } from 'hex-to-css-filter';
import { getFontURL } from 'src/utils/getFontUrl';

export const RatingAnswerSurveyStyles = () => {
  const currentIndex = useSelector(
    (state: any) => state.imageUpload.currentIndex
  );
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const titleFontURL = getFontURL(fontFamily?.title);
  const title_0201 = getFontURL(fontFamily?.title_0201);
  const title_0202 = getFontURL(fontFamily?.title_0202);
  const title_0301 = getFontURL(fontFamily?.title_0301);
  const sub_titleFontURL = getFontURL(fontFamily?.sub_title);
  const sub_title_0201 = getFontURL(fontFamily?.sub_title_0201);
  const sub_title_0202 = getFontURL(fontFamily?.sub_title_0202);
  const sub_title_0301 = getFontURL(fontFamily?.sub_title_0301);

  const buttonFontURL = getFontURL(btnFontFamily?.button);
  const button_0201 = getFontURL(btnFontFamily?.button_0201);
  const button_0202 = getFontURL(btnFontFamily?.button_0202);
  const button_0301 = getFontURL(btnFontFamily?.button_0301);

  const cta_button_0202 = getFontURL(btnFontFamily?.cta_button_0202);
  const option_button_0201 = getFontURL(btnFontFamily?.option_button_0201);
  const selected_button = getFontURL(btnFontFamily?.selected_button);
  const selected_button_0201 = getFontURL(btnFontFamily?.selected_button_0201);
  const selected_button_0202 = getFontURL(btnFontFamily?.selected_button_0202);
  const selected_button_0301 = getFontURL(btnFontFamily?.selected_button_0301);
  const selected_option_button_0201 = getFontURL(
    btnFontFamily?.selected_option_button_0201
  );
  const text_area_0301 = getFontURL(btnFontFamily?.text_area_0301);

  const CLOSE_FILTER = bgColor?.close?.[currentIndex]
    ? hexToCSSFilter(bgColor?.close?.[currentIndex])
    : { filter: '' };
  const CLOSE_FILTER_0201 = bgColor?.close_0201?.[currentIndex]
    ? hexToCSSFilter(bgColor?.close_0201?.[currentIndex])
    : { filter: '' };
  const CLOSE_FILTER_0202 = bgColor?.close_0202?.[currentIndex]
    ? hexToCSSFilter(bgColor?.close_0202?.[currentIndex])
    : { filter: '' };
  const CLOSE_FILTER_0301 = bgColor?.close_0301?.[currentIndex]
    ? hexToCSSFilter(bgColor?.close_0301?.[currentIndex])
    : { filter: '' };

  const SELECTED_FILTER = btnColor?.selected_option_button
    ? hexToCSSFilter(btnColor?.selected_option_button)
    : { filter: '' };
  const NONE_FILTER = btnColor?.option_button
    ? hexToCSSFilter(btnColor?.option_button)
    : { filter: '' };
  const STAR_IMAGE = 'https://image.inappmessage.com/sample/black-star.png';
  return `
  @font-face {
    font-family: 'titleFont';
    src: url(${titleFontURL});
  }
  @font-face {
    font-family: 'title_0201';
    src: url(${title_0201});
  }
  @font-face {
    font-family: 'title_0202';
    src: url(${title_0202});
  }
  @font-face {
    font-family: 'title_0301';
    src: url(${title_0301});
  }
  @font-face {
    font-family: 'sub_titleFont';
    src: url(${sub_titleFontURL});
  }
  @font-face {
    font-family: 'sub_title_0201';
    src: url(${sub_title_0201});
  }
  @font-face {
    font-family: 'sub_title_0202';
    src: url(${sub_title_0202});
  }
  @font-face {
    font-family: 'sub_title_0301';
    src: url(${sub_title_0301});
  }
  @font-face {
    font-family: 'buttonFont';
    src: url(${buttonFontURL});
  }
  @font-face {
    font-family: 'button_0201';
    src: url(${button_0201});
  }
  @font-face {
    font-family: 'button_0202';
    src: url(${button_0202});
  }
  @font-face {
    font-family: 'button_0301';
    src: url(${button_0301});
  }
  @font-face {
    font-family: 'cta_button_0202';
    src: url(${cta_button_0202});
  }
  @font-face {
    font-family: 'option_button_0201';
    src: url(${option_button_0201});
  }
  @font-face {
    font-family: 'selected_button';
    src: url(${selected_button});
  }
  @font-face {
    font-family: 'selected_button_0201';
    src: url(${selected_button_0201});
  }
  @font-face {
    font-family: 'selected_button_0202';
    src: url(${selected_button_0202});
  }
  @font-face {
    font-family: 'selected_button_0301';
    src: url(${selected_button_0301});
  }
  @font-face {
    font-family: 'selected_option_button_0201';
    src: url(${selected_option_button_0201});
  }
  @font-face {
    font-family: 'text_area_0301';
    src: url(${text_area_0301});
  }
    .root_view {
      width: 100%;
      height: 100%;
  
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.8);
  
      .template {
        width: 100%;
        max-width: 375px;
        height: 100%;
        max-height: 812px;
        margin: auto;
        position: relative;
      }
  
      .center_horizon {
          width: 80%;
          max-width: 300px;
  
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0%);
      }
    
      .close {
        top: 6%;
        display: flex;
        justify-content: end;
      }
      .close button {
        width: 24px;
        height: 24px;
        
        background-image: url("https://image.inappmessage.com/sample/black-close.png");
        background-repeat: no-repeat !important;
        background-size: cover !important;
        background-position: center !important;
        filter: ${CLOSE_FILTER.filter};

        font-size: 0;
        border: none;
        background-color: transparent;
      }
    
      .center_wrapper {
        width: 80%;
        padding: 32px 12px;
        max-width: 300px;
        display: flex;
        flex-direction: column;

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 16px;

        background-repeat: no-repeat !important;
        background-size: cover !important;
        background-position: center !important;
        background: #fff;
        border-radius: ${radius?.background}px;
        ${
          bg?.background === 'image'
            ? `background-image: url(${bgImage?.background});`
            : `background: ${bgColor?.background};`
        };
      }
    
      .center_wrapper .logo {
        width: 100%;
        height: 96px;

        display: flex;
        justify-content: center;
        align-items: center;
      }
      .logo button {
        width: 100%;
        height: 100%;

        background-image: url(${bgImage?.logo?.[currentIndex]});
        background-repeat: no-repeat !important;
        background-size: contain !important;
        background-position: center !important;

        font-size: 0;
        border: none;
        background-color: transparent;
      }
    
      .center_wrapper .title {
        width: 100%;
        height: 80px;

        display: flex;
        justify-content: center;
        align-items: center;

        text-align: ${textAlign?.title};
        color: ${color?.title};
        font-size: ${fontSize?.title}rem;
        font-weight: ${fontWeight?.title};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.title
          )
            ? fontFamily?.title
            : 'titleFont'
        };
      }
      .center_wrapper .title_inner {
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .center_wrapper .sub_title {
        width: 100%;
        height: 80px;
        margin-bottom: 32px;

        display: flex;
        justify-content: center;
        align-items: center;

        text-align: ${textAlign?.sub_title};
        color: ${color?.sub_title};
        font-size: ${fontSize?.sub_title}rem;
        font-weight: ${fontWeight?.sub_title};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.sub_title
          )
            ? fontFamily?.sub_title
            : 'sub_titleFont'
        };
      }
      .center_wrapper .sub_title_inner {
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
      }
    
      .star_wrapper {
        height: 40px;
        display: flex;
        justify-content: center;
        gap: 8px;
      }
      .star_inner button {
        width: 40px;
        height: 40px;
        
        background-image: url(${STAR_IMAGE});
        background-repeat: no-repeat !important;
        background-size: cover !important;
        background-position: center !important;

        font-size: 0;
        border: none;
        background-color: transparent;
        filter: ${NONE_FILTER.filter};
      }
      .star_inner.action button {
        filter: ${SELECTED_FILTER.filter};
      }
  
      .bottom {
        width: 100%;
        height: 48px;
        bottom: 32px;

        display: flex;
        gap: 16px;
      }
      .bottom button {
        width: 100%;
        height: 48px;
        border: 0;
      }
      .button {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        color: ${btnColor?.button};
        font-size: ${btnFontSize?.button}rem;
        font-weight: ${btnFontWeight?.button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.button
          )
            ? btnFontFamily?.button
            : 'buttonFont'
        };

        border-radius: ${radius?.button}px;
        background-color: rgba(${btnBgColorR?.button},${btnBgColorG?.button},${
    btnBgColorB?.button
  },${btnBgColorA?.button});
      }
      .button.action {
        color: ${btnColor?.selected_button};
        font-size: ${btnFontSize?.selected_button}rem;
        font-weight: ${btnFontWeight?.selected_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.selected_button
          )
            ? btnFontFamily?.selected_button
            : 'selected_button'
        };

        border-radius: ${radius?.selected_button}px;
        background-color: rgba(${btnBgColorR?.selected_button},${
    btnBgColorG?.selected_button
  },${btnBgColorB?.selected_button},${btnBgColorA?.selected_button});
      }
    }

    .root_view_0201 {
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center !important;
      background: #fff;
      ${
        bg?.background_0201 === 'image'
          ? `background-image: url(${bgImage?.background_0201});`
          : `background: ${bgColor?.background_0201};`
      };

      .close button {
        filter: ${CLOSE_FILTER_0201.filter};
      }

      .center_wrapper {
        padding: 0;
        background: transparent;
      }
      
      .center_wrapper .title {
        text-align: ${textAlign?.title_0201};
        color: ${color?.title_0201};
        font-size: ${fontSize?.title_0201}rem;
        font-weight: ${fontWeight?.title_0201};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.title_0201
          )
            ? fontFamily?.title_0201
            : 'title_0201'
        };
      }
      .center_wrapper .sub_title {
        margin-bottom: 0;
        text-align: ${textAlign?.sub_title_0201};
        color: ${color?.sub_title_0201};
        font-size: ${fontSize?.sub_title_0201}rem;
        font-weight: ${fontWeight?.sub_title_0201};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.sub_title_0201
          )
            ? fontFamily?.sub_title_0201
            : 'sub_title_0201'
        };
      }

      .star_wrapper {
        margin-bottom: 6.4px;
      }

      .survey_wrapper {
        width: 100%;
        height: 180px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .survey_inner {
        width: 100%;
        flex-wrap: wrap;
        display: flex;
        justify-content: center;
        gap: 12.8px;
      }
      .survey {
        height: 35px;
        padding: 0 16px;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        
        display: flex;
        justify-content: center;
        align-items: center;

        color: ${btnColor?.option_button_0201};
        font-size: ${btnFontSize?.option_button_0201}rem;
        font-weight: ${btnFontWeight?.option_button_0201};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.option_button_0201
          )
            ? btnFontFamily?.option_button_0201
            : 'option_button_0201'
        };

        border-radius: ${radius?.option_button_0201}px;
        background-color: rgba(${btnBgColorR?.option_button_0201},${
    btnBgColorG?.option_button_0201
  },${btnBgColorB?.option_button_0201},${btnBgColorA?.option_button_0201});
      }
      .survey.action {
        color: ${btnColor?.selected_option_button_0201};
        font-size: ${btnFontSize?.selected_option_button_0201}rem;
        font-weight: ${btnFontWeight?.selected_option_button_0201};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.selected_option_button_0201
          )
            ? btnFontFamily?.selected_option_button_0201
            : 'selected_option_button_0201'
        };

        border-radius: ${radius?.selected_option_button_0201}px;
        background-color: rgba(${btnBgColorR?.selected_option_button_0201},${
    btnBgColorG?.selected_option_button_0201
  },${btnBgColorB?.selected_option_button_0201},${
    btnBgColorA?.selected_option_button_0201
  });
      }

      .button {
        color: ${btnColor?.button_0201};
        font-size: ${btnFontSize?.button_0201}rem;
        font-weight: ${btnFontWeight?.button_0201};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.button_0201
          )
            ? btnFontFamily?.button_0201
            : 'button_0201'
        };

        border-radius: ${radius?.button_0201}px;
        background-color: rgba(${btnBgColorR?.button_0201},${
    btnBgColorG?.button_0201
  },${btnBgColorB?.button_0201},${btnBgColorA?.button_0201});
      }
      .button.action {
        color: ${btnColor?.selected_button_0201};
        font-size: ${btnFontSize?.selected_button_0201}rem;
        font-weight: ${btnFontWeight?.selected_button_0201};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.selected_button_0201
          )
            ? btnFontFamily?.selected_button_0201
            : 'selected_button_0201'
        };

        background-color: rgba(${btnBgColorR?.selected_button_0201},${
    btnBgColorG?.selected_button_0201
  },${btnBgColorB?.selected_button_0201},${btnBgColorA?.selected_button_0201});
      }
    }

    .root_view_0202 {
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center !important;
      background: #fff;
      ${
        bg?.background_0202 === 'image'
          ? `background-image: url(${bgImage?.background_0202});`
          : `background: ${bgColor?.background_0202};`
      };

      .close button {
        filter: ${CLOSE_FILTER_0202.filter};
      }

      .center_wrapper {
        padding: 0;
        background: transparent;
      }
      
      .center_wrapper .title {
        text-align: ${textAlign?.title_0202};
        color: ${color?.title_0202};
        font-size: ${fontSize?.title_0202}rem;
        font-weight: ${fontWeight?.title_0202};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.title_0202
          )
            ? fontFamily?.title_0202
            : 'title_0202'
        };
      }
      .center_wrapper .sub_title {
        margin-bottom: 0;
        text-align: ${textAlign?.sub_title_0202};
        color: ${color?.sub_title_0202};
        font-size: ${fontSize?.sub_title_0202}rem;
        font-weight: ${fontWeight?.sub_title_0202};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.sub_title_0202
          )
            ? fontFamily?.sub_title_0202
            : 'sub_title_0202'
        };
      }

      .star_wrapper {
        margin-bottom: 20px;
      }

      .cta_button {
        width: 100%;
        height: 40px;
      }
      .cta_button button {
        width: 100%;
        height: 48px;
        border: 0;

        display: flex;
        justify-content: center;
        align-items: center;
        
        color: ${btnColor?.cta_button_0202};
        font-size: ${btnFontSize?.cta_button_0202}rem;
        font-weight: ${btnFontWeight?.cta_button_0202};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.cta_button_0202
          )
            ? btnFontFamily?.cta_button_0202
            : 'cta_button_0202'
        };

        border-radius: ${radius?.cta_button_0202}px;
        background-color: rgba(${btnBgColorR?.cta_button_0202},${
    btnBgColorG?.cta_button_0202
  },${btnBgColorB?.cta_button_0202},${btnBgColorA?.cta_button_0202});
      }

      .button {
        color: ${btnColor?.button_0202};
        font-size: ${btnFontSize?.button_0202}rem;
        font-weight: ${btnFontWeight?.button_0202};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.button_0202
          )
            ? btnFontFamily?.button_0202
            : 'button_0202'
        };

        border-radius: ${radius?.button_0202}px;
        background-color: rgba(${btnBgColorR?.button_0202},${
    btnBgColorG?.button_0202
  },${btnBgColorB?.button_0202},${btnBgColorA?.button_0202});
      }
      .button.action {
        color: ${btnColor?.selected_button_0202};
        font-size: ${btnFontSize?.selected_button_0202}rem;
        font-weight: ${btnFontWeight?.selected_button_0202};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.selected_button_0202
          )
            ? btnFontFamily?.selected_button_0202
            : 'selected_button_0202'
        };

        background-color: rgba(${btnBgColorR?.selected_button_0202},${
    btnBgColorG?.selected_button_0202
  },${btnBgColorB?.selected_button_0202},${btnBgColorA?.selected_button_0202});
      }
    }

    .root_view_0301 {
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center !important;
      background: #fff;
      ${
        bg?.background_0301 === 'image'
          ? `background-image: url(${bgImage?.background_0301});`
          : `background: ${bgColor?.background_0301};`
      };

      .close button {
        filter: ${CLOSE_FILTER_0301.filter};
      }

      .center_wrapper {
        padding: 0;
        background: transparent;
      }
      
      .center_wrapper .title {
        text-align: ${textAlign?.title_0301};
        color: ${color?.title_0301};
        font-size: ${fontSize?.title_0301}rem;
        font-weight: ${fontWeight?.title_0301};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.title_0301
          )
            ? fontFamily?.title_0301
            : 'title_0301'
        };
      }
      .center_wrapper .sub_title {
        margin-bottom: 0;
        text-align: ${textAlign?.sub_title_0301};
        color: ${color?.sub_title_0301};
        font-size: ${fontSize?.sub_title_0301}rem;
        font-weight: ${fontWeight?.sub_title_0301};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.sub_title_0301
          )
            ? fontFamily?.sub_title_0301
            : 'sub_title_0301'
        };
      }

      .star_wrapper {
        margin-bottom: 20px;
      }

      .textarea {
        width: 100%;
        min-height: 57.6px;
        padding: 12.8px;

        resize: none;
        border: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        
        color: ${btnColor?.text_area_0301};
        font-size: ${btnFontSize?.text_area_0301}rem;
        font-weight: ${btnFontWeight?.text_area_0301};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.text_area_0301
          )
            ? btnFontFamily?.text_area_0301
            : 'text_area_0301'
        };

        border-radius: ${radius?.text_area_0301}px;
        background-color: rgba(${btnBgColorR?.text_area_0301},${
    btnBgColorG?.text_area_0301
  },${btnBgColorB?.text_area_0301},${btnBgColorA?.text_area_0301});
      }

      .button {
        color: ${btnColor?.button_0301};
        font-size: ${btnFontSize?.button_0301}rem;
        font-weight: ${btnFontWeight?.button_0301};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.button_0301
          )
            ? btnFontFamily?.button_0301
            : 'button_0301'
        };

        border-radius: ${radius?.button_0301}px;
        background-color: rgba(${btnBgColorR?.button_0301},${
    btnBgColorG?.button_0301
  },${btnBgColorB?.button_0301},${btnBgColorA?.button_0301});
      }
      .button.action {
        color: ${btnColor?.selected_button_0301};
        font-size: ${btnFontSize?.selected_button_0301}rem;
        font-weight: ${btnFontWeight?.selected_button_0301};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.selected_button_0301
          )
            ? btnFontFamily?.selected_button_0301
            : 'selected_button_0301'
        };

        background-color: rgba(${btnBgColorR?.selected_button_0301},${
    btnBgColorG?.selected_button_0301
  },${btnBgColorB?.selected_button_0301},${btnBgColorA?.selected_button_0301});
      }
    }
  `;
};
